import axios from 'axios'

const state = {
    code: "",
    data: "",
    // API実行時のタイムアウト処理を定義
    timeout : 60 * 1000
}

const getters = {
    getApiInfoStatus(state) {
        return state.code
    },
    getApiInfo(state) {
        return state.data
    },
    postApiInfo(state) {
        return state.data
    },
    putApiInfo(state) {
        return state.data
    }
}

const mutations = {
    getApiInfo(state, payload) {
        state.data = payload.data
        state.code = payload.code
    },
    postApiInfo(state, payload) {
        state.data = payload.data
    },
    putApiInfo(state, payload) {
        state.data = payload.data
    }
}

const actions = {
    /************************************************************************************************/
    // APIで情報（GET）を取得のための処理
    // API取得するのを待ってから、mutationsにcommit
    /************************************************************************************************/
    // 【引数】
    // context : ストアインスタンスのメソッドやプロパティのセットと同じものを呼び出せるコンテキストオブジェクト
    // payload : vuex呼び出し元よりdispatchされた際に受け取る引数
    /************************************************************************************************/
    async getApiInfoAction(context, payload) {
        const payload_data = {
            code:"",
            data: "",
        }
        // APIを投げて、正常時：resolve、異常時：rejectを投げる
        // API投下後、最終的にmutationsにcommitをする
        await new Promise((resolve, reject) => {
            axios.get(payload.url, {
                params: payload.params,
                timeout: state.timeout
            })
            .then(response => {
                payload_data.code = response.status
                payload_data.data = response.data
                resolve(response)
            }).catch(error => {
                payload_data.code = error.status
                payload_data.data = error
                reject(error)
            }).finally(() => {
                context.commit('getApiInfo', payload_data)
            })
        })
    },
    /************************************************************************************************/
    // APIで情報（GET）を取得のための処理
    // API取得するのを待ってから、mutationsにcommit
    /************************************************************************************************/
    // 【引数】
    // context : ストアインスタンスのメソッドやプロパティのセットと同じものを呼び出せるコンテキストオブジェクト
    // payload : vuex呼び出し元よりdispatchされた際に受け取る引数
    /************************************************************************************************/
    async postApiInfoAction(context, payload) {
        const payload_data = {
            data: "",
        }
        // APIを投げて、正常時：resolve、異常時：rejectを投げる
        // API投下後、最終的にmutationsにcommitをする
        await new Promise((resolve, reject) => {
            axios.post(payload.url, payload.params
                ).then(response => {
                    payload_data.data = response.data
                    resolve(response)
                }).catch(error => {
                    payload_data.data = error
                    reject(error)
                }).finally(() => {
                    context.commit('postApiInfo', payload_data)
                })
        })
    },
    /************************************************************************************************/
    // APIで情報を削除するための処理
    /************************************************************************************************/
    // 【引数】
    // context : ストアインスタンスのメソッドやプロパティのセットと同じものを呼び出せるコンテキストオブジェクト
    // payload : vuex呼び出し元よりdispatchされた際に受け取る引数
    /************************************************************************************************/
    async deleteApiInfoAction(context, payload) {
        const payload_data = {
            data: "",
        }
        await new Promise((resolve, reject) => {
            axios.delete(payload.url, {
                data: payload.params, 
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                timeout: state.timeout
            })
            .then(response => {
                payload_data.data = response.data
                resolve(response)
            }).catch(error => {
                payload_data.data = error
                reject(error)
            }).finally(() => {
                context.commit('getApiInfo', payload_data)
            })
        })
    },
    /************************************************************************************************/
    // APIで情報を更新するための処理
    /************************************************************************************************/
    // 【引数】
    // context : ストアインスタンスのメソッドやプロパティのセットと同じものを呼び出せるコンテキストオブジェクト
    // payload : vuex呼び出し元よりdispatchされた際に受け取る引数
    /************************************************************************************************/
    async putApiInfoAction(context, payload) {
        const payload_data = {
            data: "",
        }
        await new Promise((resolve, reject) => {
            axios.put(payload.url, {
                data: payload.params,
                timeout: state.timeout
            })
            .then(response => {
                payload_data.data = response.data
                resolve(response)
            }).catch(error => {
                payload_data.data = error
                reject(error)
            }).finally(() => {
                context.commit('putApiInfo', payload_data)
            })
        })
    }
}

const requestApi = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


export default requestApi